import { render, staticRenderFns } from "./PantallaComprobaTabla.vue?vue&type=template&id=b194f68c&lang=true&"
import script from "./PantallaComprobaTabla.vue?vue&type=script&lang=js&"
export * from "./PantallaComprobaTabla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports